import React, { useState, ReactNode } from 'react';
import cx from 'clsx';

import { IconRcRightTriangle } from 'assets';

import './index.css';

interface PanelProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

// just used to collect props
const Panel = (props: PanelProps) => null;

interface CollapseProps {
  accordion?: boolean;
  defaultActiveKey?: number[];
  onChange?(arg: number[]): void;
  children?: ReactNode;
  className?: string;
}

export const Collapse = ({
  accordion,
  defaultActiveKey = [],
  onChange,
  children,
  className,
}: CollapseProps) => {
  const [activeKeys, setActiveKeys] = useState<number[]>(defaultActiveKey);

  const handlePanelClick = ({ currentTarget }: React.MouseEvent<HTMLDivElement>) => {
    const { idx } = currentTarget.dataset;
    let result = [];

    const existIdx = activeKeys.indexOf(Number(idx));
    if (existIdx !== -1) {
      activeKeys.splice(existIdx, 1);
      result = [...activeKeys];
    } else {
      result = activeKeys.concat(Number(idx));
    }
    setActiveKeys(result);
    onChange?.(result);
  };

  return (
    <div className={cx('db-collapse', className)}>
      {React.Children.map(children as React.ReactElement<PanelProps>[], (child, i) => {
        const { className, title, children } = child.props;
        const isActive = activeKeys.includes(i);
        return (
          <div className={cx('db-panel', isActive && 'is-active', className)} key={i.toString()}>
            <div className={'db-panelTitle'} onClick={handlePanelClick} data-idx={i}>
              {title}
              <IconRcRightTriangle
                className={cx('db-panelArrow', isActive && 'is-active', className)}
              />
            </div>
            <div className={cx('db-panelBody', isActive && 'is-active')}>{children}</div>
          </div>
        );
      })}
    </div>
  );
};

Collapse.Panel = Panel;

export default Collapse;
